import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_3082ee86 from 'nuxt_plugin_plugin_3082ee86' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_2731d3dc from 'nuxt_plugin_nuxtleaflet_2731d3dc' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_46a0c0fb from 'nuxt_plugin_cookieuniversalnuxt_46a0c0fb' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_httpserver_08195c00 from 'nuxt_plugin_httpserver_08195c00' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_47ff96c6 from 'nuxt_plugin_http_47ff96c6' // Source: ./http.js (mode: 'all')
import nuxt_plugin_strapi_881c7888 from 'nuxt_plugin_strapi_881c7888' // Source: ./strapi.js (mode: 'all')
import nuxt_plugin_workbox_b0b3d8a2 from 'nuxt_plugin_workbox_b0b3d8a2' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_iconplugin_52a83d94 from 'nuxt_plugin_iconplugin_52a83d94' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_e47bb15a from 'nuxt_plugin_axios_e47bb15a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_vuescrollto_2a1bb871 from 'nuxt_plugin_vuescrollto_2a1bb871' // Source: ../plugins/vue-scrollto.js (mode: 'client')
import nuxt_plugin_veevalidate_3f7cf8b3 from 'nuxt_plugin_veevalidate_3f7cf8b3' // Source: ../plugins/vee-validate.js (mode: 'client')
import nuxt_plugin_vueslider_67889378 from 'nuxt_plugin_vueslider_67889378' // Source: ../plugins/vue-slider.js (mode: 'client')
import nuxt_plugin_vuetouch_477267d4 from 'nuxt_plugin_vuetouch_477267d4' // Source: ../plugins/vue-touch.js (mode: 'client')
import nuxt_plugin_ga_fb0a2534 from 'nuxt_plugin_ga_fb0a2534' // Source: ../plugins/ga.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page-fade","mode":"in-out","css":true,"type":"animation","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | Northbank Civil and Marine, Inc.","meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Marine, Heavy Civil and Industrial Construction Northbank Civil and Marine serves Oregon, Washington, Idaho, California and Montana with high quality"},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-config","content":"\u002F_favicons\u002Fbrowserconfig.xml"},{"name":"theme-color","content":"#ffffff"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Northbank Civil and Marine, Inc."},{"hid":"author","name":"author","content":"Northbank Civil and Marine, Inc."},{"hid":"geo.region","name":"geo.region","property":"geo.region","content":"US-OR"},{"hid":"geo.placename","name":"geo.placename","property":"geo.placename","content":"Portland"},{"hid":"geo.position","name":"geo.position","property":"geo.position","content":"45.5242295,-122.6603156"},{"hid":"ICBM","name":"ICBM","property":"ICBM","content":"45.5242295,-122.6603156"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Northbank Civil and Marine, Inc."},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Northbank Civil and Marine, Inc."},{"hid":"og:description","name":"og:description","property":"og:description","content":"options.ogDescription"},{"hid":"og:url","name":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.northbankcm.com\u002F"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.northbankcm.com\u002F\u002F_nuxt\u002Ficons\u002Ficon_512x512.6615bf.png"},{"hid":"og:image:secure_url","name":"og:image:secure_url","property":"og:image:secure_url","content":"https:\u002F\u002Fwww.northbankcm.com\u002F\u002F_nuxt\u002Ficons\u002Ficon_512x512.6615bf.png"},{"hid":"og:image:width","name":"og:image:width","property":"og:image:width","content":512},{"hid":"og:image:height","name":"og:image:height","property":"og:image:height","content":512},{"hid":"og:image:type","name":"og:image:type","property":"og:image:type","content":"image\u002Fpng"},{"hid":"og:image:alt","name":"og:image:alt","property":"og:image:alt","content":"Northbank Civil and Marine, Inc."},{"hid":"twitter:card","name":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:creator","name":"twitter:creator","property":"twitter:creator","content":"Northbank Civil and Marine, Inc."},{"hid":"twitter:title","name":"twitter:title","property":"twitter:title","content":"Northbank Civil and Marine, Inc."},{"hid":"twitter:description","name":"twitter:description","property":"twitter:description","content":"Northbank Civil and Marine serves Oregon, Washington, Idaho, California and Montana with high quality marine, heavy civil and industrial construction services."},{"hid":"twitter:image","name":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fwww.northbankcm.com\u002Fstatic\u002Fassets\u002Fsocial_logo_1200x600.jpg"},{"hid":"twitter:site","name":"twitter:site","property":"twitter:site","content":"Northbank Civil and Marine, Inc."}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002F_favicons\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002F_favicons\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002F_favicons\u002Ffavicon-16x16.png"},{"href":"\u002F_favicons\u002Fsafari-pinned-tab.svg","color":"#5bbad5"},{"rel":"shortcut icon","href":"\u002F_favicons\u002Ffavicon.ico"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.47c8914f.json"}],"script":[{}],"style":[],"title":"Northbank Civil and Marine, Inc.","htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_3082ee86 === 'function') {
    await nuxt_plugin_plugin_3082ee86(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_2731d3dc === 'function') {
    await nuxt_plugin_nuxtleaflet_2731d3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_46a0c0fb === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_46a0c0fb(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_08195c00 === 'function') {
    await nuxt_plugin_httpserver_08195c00(app.context, inject)
  }

  if (typeof nuxt_plugin_http_47ff96c6 === 'function') {
    await nuxt_plugin_http_47ff96c6(app.context, inject)
  }

  if (typeof nuxt_plugin_strapi_881c7888 === 'function') {
    await nuxt_plugin_strapi_881c7888(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_b0b3d8a2 === 'function') {
    await nuxt_plugin_workbox_b0b3d8a2(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_52a83d94 === 'function') {
    await nuxt_plugin_iconplugin_52a83d94(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_e47bb15a === 'function') {
    await nuxt_plugin_axios_e47bb15a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_2a1bb871 === 'function') {
    await nuxt_plugin_vuescrollto_2a1bb871(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_3f7cf8b3 === 'function') {
    await nuxt_plugin_veevalidate_3f7cf8b3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslider_67889378 === 'function') {
    await nuxt_plugin_vueslider_67889378(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouch_477267d4 === 'function') {
    await nuxt_plugin_vuetouch_477267d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ga_fb0a2534 === 'function') {
    await nuxt_plugin_ga_fb0a2534(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
